export default {
  account_owner:'Kontoinhaber',
  owner:'Kontoinhaber',
  created_at:'Aktiv seit',
  BIC:'BIC',
  IBAN:'IBAN',
  bic:'BIC',
  iban:'IBAN',
  account:'Konto',
  amount:'Kontostand',
  reserved_amount:'Reserviert',
  credit_limit:'Verfügungsrahmen',
  transaction:'Transaktionsbetrag',
  payment:'Zahlungsart',
  charge:'Zahlungsgebühren',
  credit:'Gutschrift',
  transfer:'Überweisung',
  paypal:'Paypal',
  charge_account:'Konto aufladen',
  debit_text:'Ich ermächtigen LUMASERV Systems, Jan Waldecker, Zahlungen von meinem Konto mittels Lastschrift einzuziehen. Zugleich weise ich mein Kreditinstitut an, die von LUMASERV Systems auf mein Konto gezogenen Lastschriften einzulösen.\n' +
    '\n' +
    'Hinweis: Ich kann innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen.\n' +
    '\n' +
    'Es gelten dabei die mit meinem Kreditinstitut vereinbarten Bedingungen. Ich akzeptiere, dass für die Vorankündigung der Basis-Lastschriften eine verkürzte Frist von einem Kalendertag gilt.'
}



// WEBPACK FOOTER //
// ./src/lang/de/accounting.js